import ModalActionsSalesHistoriesItem from './ModalActionsSalesHistoriesItem'
export default ModalActionsSalesHistoriesItem